import { html } from "lit-element";
import "@stofloos/components/atoms/buttons/button-outlined";
import { StofwarePageCrud } from "@stofloos/core/base/sw-page-crud";
import "@stofloos/components/organisms/tables/table-dynamic";
import { localize } from "@stofloos/actions/localize";
import { store } from "@stofloos/stores/store";
import { incrementPage } from "@stofloos/actions/requests";
import { LayoutFlex } from "@stofloos/globals/styles/layout-flex";
import { openDialog } from "@stofloos/actions/dialog";
import "@stofloos/components/molecules/dialogs/dialog-simple";
import "@stofloos/components/molecules/forms/sw-form";
import "@stofloos/components/atoms/headers/sw-header-filters";
import "@stofloos/components/atoms/headers/sw-header-actions";

import { style } from "./style";

import { icon } from "@fortawesome/fontawesome-svg-core";
import { faTrashAlt } from "@fortawesome/free-regular-svg-icons";

class StofwarePageTable extends StofwarePageCrud {
	static get properties() {
		return {
			label: String,
			identifier: String,

		};
	}

	constructor() {
		super();

		this.addEventListener("sw-table:read-object", this.showObject);
	}

	static get styles() {
		return [LayoutFlex, style];
	}

	render() {
		return html`
			${this.meta.filter_options ? html`
				<sw-header-filters endpoint="${this.endpoint}" .meta="${this.meta}"></sw-header-filters>
			`: ``}
			
			<sw-header-actions endpoint="${this.endpoint}" title="${this.label}">
				<button-outlined
					@click="${() => store.dispatch(openDialog("createObjectDialog"))}"
					label="${localize("main::create")}"
					lowecase
					strong
				></button-outlined>
			</sw-header-actions>

			<div class="page-container layout vertical">
				<table-dynamic
					endpoint="${this.endpoint}"
					requestId="${this.requestId}"
					identifier="${this.identifier}"
					.objects="${this.objects}"
					.meta="${this.meta}"
				></table-dynamic>
				${this.hasMorePages
					? html`
							<button-outlined
								lowecase
								strong
								@click="${() => store.dispatch(incrementPage(this.requestId, true))}"
								label="${localize("main::load_more")}"
							></button-outlined>
					  `
					: ""}
			</div>

			<dialog-simple y-animation dialogId="editObjectDialog">
				${this.object
					? html`
							<button-outlined
								lowecase
								strong
								app-red
								@click="${() => store.dispatch(openDialog("deleteObjectDialog"))}"
								><icon app-red>${icon(faTrashAlt).node}</icon></button-outlined
							>

							<sw-form .object="${this.object}" .config="${this.meta.form}"></sw-form>
							<div class="layout vertical center-center">
								<button-outlined
									lowecase
									strong
									@click="${this.updateObject}"
									label="${localize("main::save")}"
								></button-outlined>
							</div>
					  `
					: ""}
			</dialog-simple>

			<dialog-simple y-animation dialogId="createObjectDialog">
				<sw-form .config="${this.meta.form_create ? this.meta.form_create : this.meta.form}"></sw-form>
				<div class="layout vertical center-center">
					<button-outlined lowecase strong @click="${this.createObject}" label="${localize("main::add")}">
					</button-outlined>
				</div>
			</dialog-simple>
		`;
	}

	showObject(e) {
		const object = e.detail.object;
		this.object = object;
		store.dispatch(openDialog("editObjectDialog", e));
	}
}

window.customElements.define("sw-page-table", StofwarePageTable);
